import React, { useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import './CommonStyles.css';
import "semantic-ui-css/semantic.min.css"
import * as Utils from '../utils/Utils.js'; 
import * as AuthUtils from '../utils/AuthUtils.js';
import * as ReactUtils from "../utils/ReactUtils.js";

const TranslationHistoryPage = () => {
  // State to store the list of translations
  const [translations, setTranslations] = useState(Utils.getTranslationHistory());
  const [isUserSignedIn, setIsUserSignedIn] = useState(false);
  const [isUserSubscribed, setIsUserSubscribed] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => { 
    updateUserSignedInStateAndEmail(); 
  }, []);

  const updateUserSignedInStateAndEmail = async () => {
    const accessToken = await Utils.getUserAccesstoken();
    if (accessToken) {
      setIsUserSignedIn(true);

      const userInfo = await AuthUtils.currentUserInfo();
      if (userInfo?.attributes?.email) {
        setUserEmail(userInfo?.attributes?.email);
      }

      const subscriptionState = await Utils.getSubscriptionState(); // Utils.SubscriptionState.PREMIUM
      setIsUserSubscribed(Utils.isUserSubscribed(subscriptionState));
      // setIsUserSubscribed(true);
      if (!Utils.isUserSubscribed(subscriptionState)) {
        ReactUtils.showPurchasePremiumPopup(document.getElementById("historyList"), userEmail);
      }
    } else {
      ReactUtils.showUserSignInOrOutPopup(null, document.getElementById("historyList"), true, updateUserSignedInStateAndEmail);
    }
  };

  function clear() {
    Utils.clearTranslationHistory();
    setTranslations(Utils.getTranslationHistory());
  }

  return (
    <div>
    <meta charSet="utf-8" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/water.css@2/out/water.css"></link>
    <title>TranslateGPT</title>

    <style type="text/css">
    </style>

    <div className="ui container">
      <Header></Header>

      <div>
        <div>
          <h2 style={{ display: 'inline'}} >Translation History</h2>
          {isUserSignedIn && isUserSubscribed && 
            <button className="ui button" onClick={clear} style={{ display: 'inline', float: 'right'}}>
              Clear all translation history</button>}
        </div>
        <div id="historyList" style={{marginTop: '20px', minHeight: '400px'}}> {isUserSignedIn && 
          (isUserSubscribed 
              ? (translations?.length === 0 ? <div>No Translation History available</div>
                : <ul>
                  {translations.map((translation, index) => (
                    <li key={index}>
                      <strong>Original:</strong> {translation.originalText}<br />
                      <div style={{color: 'gray'}}>Translated on {translation.timestamp}: <br />{translation.translatedText}</div>
                      <div style={{color: 'gray'}}></div><br />
                    </li>
                  ))}
                </ul>)
              : <div style={{color: 'red'}}>Please Upgrade to see translation history!</div>)
          }
        </div>
      </div>

      <Footer></Footer>
    </div>

  </div>
  );
}

export default TranslationHistoryPage;